module.exports = __webpack_public_path__ + "static/media/KMH_5415.b47fcc42.jpg";